// extracted by mini-css-extract-plugin
export default {"modalupload":"multiplr_modalupload__uteFT"};